import { Icon } from "@/lib/components/ui/Icon/Icon";
import { useMenuContext } from "@/lib/context/MenuProvider/hooks/useMenuContext";
import { useDevice } from "@/lib/hooks/useDevice";
import { useTranslation } from "react-i18next";

import styles from "./MenuControlButton.module.scss";

export const MenuControlButton = (): JSX.Element => {
  const { t } = useTranslation("translation");
  const tx = (key: string) => t(key as any);
  const { isOpened, setIsOpened } = useMenuContext();
  const { isMobile } = useDevice();
  const iconName = isOpened ? "chevronLeft" : "chevronRight";

  if (isOpened && isMobile) {
    return <></>;
  }

  return (
    <button
      aria-label={isOpened ? tx("collapseMenu") : tx("openMenu")}
      className={styles.menu_control_button}
      onClick={() => setIsOpened(!isOpened)}
      type="button"
    >
      <Icon
        name={iconName}
        size="smaller"
        color="white"
        classname={styles.menu_icon}
      />
    </button>
  );
};
